import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=718ba53b&scoped=true"
import script from "./ResetButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResetButton.vue?vue&type=style&index=0&id=718ba53b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ba53b",
  null
  
)

export default component.exports